import { Collapse as CollapseComp, CollapseProps } from 'antd';

import {
  CaretDownDark,
  CaretUpSky,
  CollapseDown,
  CollapseRight,
} from '../../icons';
import { getClassName } from '../_utils';

type Props = Pick<
  CollapseProps,
  'accordion' | 'activeKey' | 'className' | 'onChange' | 'defaultActiveKey'
> & {
  panels: CollapsePanelDef[];
};

type CollapsePanelDef = {
  key: string;
  header: React.ReactNode;
  content: React.ReactNode;
};

export function Collapse({ className, panels, ...props }: Props) {
  /**
   * TODO: re-evaluate if we need this.
   * I'm preserving this behavior for now, but it's not clear that we need it.
   */
  const isFAQCollapse = className && className.includes('suntex-collapse--faq');
  /**
   * returns icon based on isActive value
   */
  const customExpandIcon = (panelProps: { isActive?: boolean }) => {
    const { isActive } = panelProps;
    return <span>{isActive ? <CollapseDown /> : <CollapseRight />}</span>;
  };
  /**
   * returns icon based on isActive value
   */
  const customExpandIconFAQ = (panelProps: { isActive?: boolean }) => {
    const { isActive } = panelProps;
    return <span>{isActive ? <CaretUpSky /> : <CaretDownDark />}</span>;
  };
  return (
    <CollapseComp
      className={getClassName('collapse', className)}
      expandIcon={isFAQCollapse ? customExpandIconFAQ : customExpandIcon}
      expandIconPosition="end"
      items={panels.map((p) => ({
        key: p.key,
        label: p.header,
        children: p.content,
      }))}
      {...props}
    />
  );
}
